import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const InterestService = createApi({
	reducerPath: "InterestService",
	tagTypes: "InterestDriver",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/user/",
		prepareHeaders: (headers, { getState }) => {
			const reducers = getState();
			const token = reducers?.AuthReducer?.userToken;
			headers.set("authorization", token ? `Bearer ${token}` : "");
			return headers;
		},
	}),
	endpoints: (builder) => {
		return {
			applyInterest: builder.mutation({
				query: (userData) => {
					return {
						url: "interests/store",
						method: "POST",
						body: userData,
					};
				},
				invalidatesTags: ["InterestDriver"],
			}),
			getInterest: builder.query({
				query: () => {
					return {
						url: "interests/my-interests",
						method: "GET",
					};
				},
				providesTags: ["InterestDriver"],
			}),
		};
	},
});
export const { useApplyInterestMutation, useGetInterestQuery } =
	InterestService;
export default InterestService;
